import React from 'react'
import BottomArrowSvg from './Svg/BottomArrowSvg'
import { SxProps } from '@mui/system'

interface Props {
  doNotFlow?: boolean
  directionIsReversed?: boolean
  sx?: SxProps
}

// Component to handle the straight arrow to the side for the extended live values view
const SecondLevelArrow: React.FC<Props> = ({ doNotFlow, directionIsReversed, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'
  const transform = 'translateX(0)'
  const combinedSx = { width: 'fit-content', ...sx }
  return <BottomArrowSvg transform={transform} sx={combinedSx} direction={direction} />
}

export default SecondLevelArrow
